<template>
  <FormGroup
    :label="label"
    :id="id">
    <div
      :class="{
        'input-group': $slots['input-group-prepend'] ||
          $slots['input-group-append']
    }">
      <slot name="input-group-prepend" />
      <select
        v-validate="validate"
        ref="input"
        :name="id"
        :id="id"
        :data-vv-as="label.toLowerCase()"
        :value="stringValue"
        :disabled="disabled"
        class="form-control"
        data-vv-validate-on="input|blur|revalidate"
        v-on="listeners">
        <option
          :selected="isPlaceholderSelected"
          :value="''"
          hidden />
        <option
          v-if="empty"
          :value="''" />
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :selected="value == option.value">
          {{ option.label }}
        </option>
      </select>
      <FormError :id="id" />
      <slot name="input-group-append" />
    </div>
  </FormGroup>
</template>

<script>
import generateId from '@/helpers/components/generateId';
import FormGroup from './_FormGroup';
import FormError from './_FormError';

export default {
  inject: ['$validator'],
  components: {
    FormGroup,
    FormError,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    validate: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: generateId(),
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => this.updateValue(event),
      };
    },
    stringValue() {
      if (this.value !== null) {
        return `${this.value}`;
      }
      return '';
    },
    isPlaceholderSelected() {
      return this.value === '' || (this.number && this.value === 0);
    },
  },
  methods: {
    updateValue(event) {
      if (event && event.target) {
        let { value } = event.target;
        if (this.number) {
          let numberValue = 0;

          if (value.indexOf('.') >= 0) {
            numberValue = parseFloat(value);
          } else if (value.indexOf(',') >= 0) {
            value = value.replace(',', '.');
            numberValue = parseFloat(value);
          } else {
            numberValue = parseInt(value, 10);
          }

          if (Number.isNaN(numberValue)) {
            this.$emit('input', value);
          }

          this.$emit('input', numberValue);
        } else {
          this.$emit('input', value);
        }
      }
    },
  },
};
</script>
